



























































































































import {Component, Vue, Watch} from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import EForm from "@/components/datatable/EForm.vue";
import TextField from "@/components/inputs/TextField.vue";
import EnabledSwitch from "@/components/inputs/EnabledSwitch.vue";
import {SanalPosEntity, SanalPosTemplate} from "@/entity/SanalPosEntity";

@Component({
    components: {DeleteButton, EForm, TextField, EnabledSwitch}
})
export default class SanalPos extends Vue {
    items: SanalPosEntity[] | null = null;
    templates: SanalPosTemplate[] = [];
    dialog = false;
    title: string = "";
    isNew: boolean = false;
    baseAction: string = "sanalPos";
    action: string = this.baseAction;
    data: SanalPosEntity = new SanalPosEntity();

    headers = [
        {text: "Sağlayıcı", value: "name"},
        {text: "Ortam", value: "is_test"},
        {text: "Aktif", value: "is_active"},
        {text: "Ödemede kullanılan", value: "is_default"},
        {text: "İşlemler", value: "actions", sortable: false}
    ];

    get currentFields() {
        let tpl = this.templates.find(t => t.code === this.data.code);
        return tpl ? tpl.fields : [];
    }

    // Sağlayıcı değişince, o sağlayıcıya özel (extra) alanları reaktif olarak
    // data'ya ekle (Vue 2'de yeni anahtarlar $set olmadan reaktif değildir).
    @Watch("data.code")
    onCodeChange() {
        this.ensureFields();
    }

    ensureFields() {
        this.currentFields.forEach(f => {
            if (!(f.key in this.data)) {
                this.$set(this.data, f.key, "");
            }
        });
    }

    // Ekleme için: henüz tabloda olmayan sağlayıcı şablonları
    get availableTemplates(): SanalPosTemplate[] {
        let existing = (this.items || []).map(i => i.code);
        return this.templates.filter(t => existing.indexOf(t.code) === -1);
    }

    providerName(code: string): string {
        let tpl = this.templates.find(t => t.code === code);
        return tpl ? tpl.name : code;
    }

    edit(item: SanalPosEntity) {
        this.title = "Sağlayıcıyı Düzenle";
        this.isNew = false;
        this.data = Object.assign(new SanalPosEntity(), item);
        this.action = this.baseAction + "/" + item.payment_provider_id;
        this.ensureFields();
        this.dialog = true;
    }

    add() {
        this.title = "Sağlayıcı Ekle";
        this.isNew = true;
        this.data = new SanalPosEntity();
        if (this.availableTemplates.length) {
            this.data.code = this.availableTemplates[0].code;
        }
        this.action = this.baseAction;
        this.ensureFields();
        this.dialog = true;
    }

    async setDefault(item: SanalPosEntity) {
        await this.$http.patch(this.baseAction + "/" + item.payment_provider_id + "?is_default=1");
        await this.get();
    }

    async loadTemplates() {
        let response = await this.$http.get(this.baseAction + "/templates");
        this.templates = response.data;
    }

    async get() {
        this.dialog = false;
        let response = await this.$http.get(this.baseAction);
        this.items = response.data;
    }

    async created() {
        await this.loadTemplates();
        await this.get();
    }
};
